import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteEnterprise($id: ID!) {
        deleteEnterprise(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
